// Google Material Icon: folder (documents)
export interface IIconProps {
	color?: string;
	size?: number;
}

export const IconFolder = ({ color = "currentColor", size = 24 }: IIconProps) => {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
				fill={color}
			/>
		</svg>
	);
};
